(() => {
  const dialog = document.getElementById("MarketSelectorDialog");
  if (!dialog || dialog.dataset.initialized === "true") return;

  dialog.dataset.initialized = "true";
  let returnFocus = null;

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-market-selector-open]");
    if (!trigger) return;

    returnFocus = trigger;
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
  });

  const closeButton = dialog.querySelector("[data-market-selector-close]");
  if (closeButton) closeButton.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener("close", () => {
    if (returnFocus) returnFocus.focus();
  });
})();
